export const API_URL = process.env.REACT_APP_API_URL || "/api";

const DEVICE_ID_KEY = "smartcart_device_id";

export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
